import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=43552638&scoped=true&"
import script from "./Position.vue?vue&type=script&lang=js&"
export * from "./Position.vue?vue&type=script&lang=js&"
import style0 from "./Position.vue?vue&type=style&index=0&id=43552638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43552638",
  null
  
)

export default component.exports